<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <!-- <el-form-item label="ASIN:" class="query-form-item">
                <el-input v-model="query.asin" placeholder="请输入ASIN" clearable style="width: 150px;"></el-input>
            </el-form-item> -->
            <el-form-item label="项目组:" class="query-form-item">
                <el-input
                    v-model="query.project_name"
                    placeholder="项目组"
                    clearable
                    style="width: 150px;"
                ></el-input>
            </el-form-item>
            <el-form-item label="站点:" class="query-form-item">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 100px;"
                    size="mini"
                    filterable
                    clearable
                    @change="change"
                    @clear="clearValue"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.us.toUpperCase()"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                                >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="类型: " class="query-form-item">
                <el-select
                    v-model="query.type"
                    @change="getList()"
                    style="width: 120px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in typeArr"
                        :key="item.index"
                        :label="item.title"
                        :value="item.index">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    >查询</el-button
                >
                <el-button
                    type="success"
                    icon="el-icon-upload2"
                    @click="onupload"
                    >上传防内部竞价文件</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            @sort-change="handleSortChange"
            style="width: 100%;"
        >
            <!-- <el-table-column
                label="ASIN"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin }}</div>
                </template>
            </el-table-column> -->
            <el-table-column label="项目组" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.project_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="国家" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.state == 'us'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>美国</span>
                    </div>
                    <div v-if="scope.row.state == 'de'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>德国</span>
                    </div>
                    <div v-if="scope.row.state == 'uk'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>英国</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="上传的文件名"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.filename }}</div>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.download_tag == 1" type="success"
                        >完成</el-tag
                    >
                    <el-tag v-else-if="scope.row.download_tag == 0" type="info"
                        >未完成</el-tag
                    >
                    <el-tag
                        v-else-if="scope.row.download_tag == -1"
                        type="danger"
                        >失败</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column
                label="上传时间"
                sortable="custom"
                prop="add_time"
                width="144"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time.replace(/T/g, " ") }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="280">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.import_path != null"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="download_file(scope.row, 1, scope.row.filename)"
                        >上传文件下载下载</el-button
                    >
                    <el-button
                        v-if="scope.row.export_path != null"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="
                            download_file(
                                scope.row,
                                2,
                                scope.row.filename.replace(
                                    /(.xlsx|.xls)$/,
                                    '分析文件.xlsx'
                                )
                            )
                        "
                        >分析文件下载</el-button
                    >
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_file(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <upload
            :visible="ctrl.uploadDialogVisible"
            :us_arr="us_arr"
            :title="'上传防内部竞价文件'"
            @close-callback="closeCllback"
        ></upload>
    </div>
</template>

<script>
import * as api from "@/api/adv/adv";
import Upload from "./upload";
import { binary_download } from "@/utils/method";
export default {
    props: {
        type: {
            default: 1,
            type: Number
        }
    },
    components: { Upload },
    data() {
        return {
            tableHeight: null,
            ctrl: {
                uploadDialogVisible: false
            },
            typeArr: [
                {
                    index: 1,
                    title: "广告层面"
                },
                {
                    index: 2,
                    title: "逻辑层面"
                }
            ],
            us_arr: [
                {
                    us: "us",
                    title: "美国"
                },
                {
                    us: "uk",
                    title: "英国"
                },
                {
                    us: "de",
                    title: "德国"
                }
            ],
            query: {
                page: 1,
                type: 1,
                limit: 20,
                total: 0
            },
            list: [],
            loading: false
        };
    },
    created() {
        this.query.asin = this.$route.query.asin;
        this.getList();
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
        this.query.type = this.type;
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    methods: {
        getList() {
            this.loading = true;
            api.prevent_internal_competition_show(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.detail_list;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSortChange(val) {
            if (val.order == "ascending") {
                this.query.desc = "desc";
                this.query.order = val.prop;
            } else if (val.order == "descending") {
                this.query.desc = "asc";
                this.query.order = val.prop;
            }
            this.getList();
        },
        //重置
        onReset() {
            this.query.project_name = "";
            this.query.state = "";
            this.query.asin = "";
            this.query.page = 1;
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        change() {
            this.getList();
        },
        clearValue() {
            this.query.state = "";
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true;
        },
        //下载文件
        download_file(data, num, name) {
            if (num == 2) {
                if (data.download_tag == 0) {
                    return this.$message({
                        type: "error",
                        message: "文件分析未完成!"
                    });
                } else if (data.download_tag == -1) {
                    return this.$message({
                        type: "error",
                        message: "文件分析失败，无法下载!"
                    });
                }
            }
            binary_download(
                "/apis/open_ad_group/prevent_internal_competition_download",
                "post",
                {},
                {
                    id: data.id,
                    download_type: num
                },
                "application/vnd.ms-excel",
                name
            );
        },
        //删除
        delete_file(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.prevent_internal_competition_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.uploadDialogVisible = false;
            isshow == true && this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
